import './Contact.css'
export default function Contact()
{
    return <>
        <p>Email: Ltaylr@protonmail.com</p>
    </>
}